// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3JsL2","content":"RecentSearches_content__3P914"};